import { stringifySave } from '../helpers/JsonHelpers';
/**
 * Thanks to: https://raw.githubusercontent.com/lesander/console.history/master/console-history.js
 */
var ConsoleHistory = /** @class */ (function () {
    function ConsoleHistory() {
        this.isInitialized = false;
        this.history = [];
        //#region Store the original log functions
        this.log = console.log;
        this.info = console.info;
        this.warn = console.warn;
        this.error = console.error;
        this.debug = console.debug;
    }
    //#endregion
    ConsoleHistory.prototype.initialize = function () {
        var _this = this;
        if (this.isInitialized) {
            return;
        }
        this.isInitialized = true;
        /* Redirect all calls to the collector. */
        console.log = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.interceptConsole('log', args);
        };
        console.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.interceptConsole('info', args);
        };
        console.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.interceptConsole('warn', args);
        };
        console.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.interceptConsole('error', args);
        };
        console.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.interceptConsole('debug', args);
        };
    };
    /**
     * Give the developer the ability to intercept the message before letting console-history access it.
     * @param type
     * @param args
     */
    ConsoleHistory.prototype.interceptConsole = function (type, args) {
        // Your own code can go here, but the preferred method is to override this
        // function in your own script, and add the line below to the end or
        // begin of your own 'console._intercept' function.
        // REMEMBER: Use only underscore console commands inside _intercept!
        this.collectConsole(type, args);
    };
    /**
     * Define the main log catcher.
     * @param type
     * @param args
     * @returns
     */
    ConsoleHistory.prototype.collectConsole = function (type, args) {
        // WARNING: When debugging this function, DO NOT call a modified console.log
        // function, all hell will break loose.
        // Instead use the original console._log functions.
        // All the arguments passed to any function, even when not defined
        // inside the function declaration, are stored and locally available in
        // the variable called 'arguments'.
        //
        // The arguments of the original console.log functions are collected above,
        // and passed to this function as a variable 'args', since 'arguments' is
        // reserved for the current function.
        // Collect the timestamp of the console log.
        var time = new Date().toUTCString();
        // Make sure the 'type' parameter is set. If no type is set, we fall
        // back to the default log type.
        if (!type)
            type = 'log';
        // To ensure we behave like the original console log functions, we do not
        // output anything if no arguments are provided.
        if (!args || args.length === 0)
            return;
        // Act normal, and just pass all original arguments to
        // the original console function :)
        this[type].apply(console, args);
        // Get stack trace information. By throwing an error, we get access to
        // a stack trace. We then go up in the trace tree and filter out
        // irrelevant information.
        var stack = [];
        try {
            throw Error('');
        }
        catch (error) {
            // The lines containing 'console-history.js' are not relevant to us.
            var stackParts = error.stack.split('\n');
            for (var i = 0; i < stackParts.length; i++) {
                if (stackParts[i].includes('ConsoleHistory') &&
                    stackParts[i] === 'Error') {
                    continue;
                }
                stack.push(stackParts[i].trim());
            }
        }
        // Add the log to our history.
        this.history.push({
            type: type,
            timestamp: time,
            arguments: args,
            stack: stack,
        });
        if (this.history.length > 100) {
            this.history.shift();
        }
    };
    ConsoleHistory.prototype.getHistoryStringified = function () {
        return this.history.map(stringifySave);
    };
    ConsoleHistory.prototype.getHistoryStringObject = function () {
        var history = {};
        this.history.forEach(function (item, index) {
            history["console" + (index + 1)] = item;
        });
        return history;
    };
    return ConsoleHistory;
}());
export default new ConsoleHistory();
//# sourceMappingURL=ConsoleHistory.js.map